import React from "react"
import { ButtonLoadingSeeker } from "@ui-seeker/core"

import { useUserSettingsCategory, useUserSettingsCategoryValidator } from "../../../@hooks"


export default function UserSettingCategoryDrawerSubmit() {
	const { isLoading, handleSubmitCategoryFormData } = useUserSettingsCategory()
	const { isValid } = useUserSettingsCategoryValidator()

	return <ButtonLoadingSeeker
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitCategoryFormData}
	>
		Save
	</ButtonLoadingSeeker>
}